module.exports = __webpack_public_path__ + "static/upscale-64f1185b9fb9e9e0216d84e2956b96c4.jpg";